import {observer} from "mobx-react-lite";
import {AnimateLayoutChanges, defaultAnimateLayoutChanges, useSortable} from "@dnd-kit/sortable";
import React from "react";
import Container from "./Container";
import {DroppableProps} from "../../../../entity/props/document/droppable-props";
import {SortableContextItem} from "./SortableContextItem";
import {useService} from "../../../../infrastructure/service/service";

import '../../../../assets/css/document/droppable-container.css';

const DroppableContainer = (props: DroppableProps): JSX.Element => {
    const {sectionService} = useService();

    const id = props.id;
    const items = props.items[id];
    const animateLayoutChanges: AnimateLayoutChanges = (args): boolean => defaultAnimateLayoutChanges({...args, wasDragging: true});

    const {active, attributes, isDragging, listeners, over, setNodeRef, transition} = useSortable({
        id,
        data: {
            type: 'container',
            children: items,
        },
        animateLayoutChanges
    });

    const isOverContainer = over ? (id === over.id && active?.data.current?.type !== 'container') || (items && items.includes(over.id)) : false;

    const getClassName = (): string => {
        let className = 'draggable-container scrollable';

        if (isOverContainer)
            className = className + ' hover';

        if (props.minimal)
            className = className + ' un-styled';

        return className;
    }

    return (
        <Container
            project={props.project}
            ref={setNodeRef}
            label={props.label}
            style={{transition, opacity: isDragging ? 0.5 : undefined}}
            itemCount={items?.length ?? 0}
            handleProps={{...attributes, ...listeners}}
            setUpdatedSections={props.setUpdatedSections}
            setItems={props.setItems}
            className={getClassName()}
            isNonSection={props.isNonSection}
            onRemove>
            {
                props.isNonSection || sectionService.getExpandSectionIds().includes(props.id)
                    ? <SortableContextItem
                        items={props.items}
                        containerId={props.id as string}
                        activeId={props.activeId}
                        project={props.project}
                        setItems={props.setItems}
                        setUpdatedSections={props.setUpdatedSections}/>
                    : null
            }
        </Container>
    );
}

export default observer(DroppableContainer);
